import FormOptColumn from "./components/FormOptColumn";
import StatusColumn from "./components/StatusColumn";
import NameColumn from "./components/NameColumn";
import TypeColumn from "./components/TypeColumn";
import i18n from "@/i18n";

export const formListTable = () => {
    return {
        columns: [
            {
                colId: "type",
                header: i18n.t("zhiji.form.type"),
                type: "Custom",
                width: "8%",
                component: TypeColumn
            },
            {
                colId: "name",
                header: i18n.t("zhiji.form.formName"),
                type: "Custom",
                width: "12%",
                component: NameColumn
            },
            {
                colId: "formId",
                header: i18n.t("zhiji.form.formId"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "language",
                header: i18n.t("zhiji.common.language"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "tag",
                header: i18n.t("zhiji.form.tag"),
                type: "Text",
                width: ""
            },
            {
                colId: "creator",
                header: i18n.t("zhiji.common.creator"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "createTime",
                header: i18n.t("zhiji.common.createTime"),
                type: "Text",
                width: "14%"
            },
            {
                colId: "state",
                header: i18n.t("zhiji.common.status"),
                type: "Custom",
                width: "8%",
                component: StatusColumn
            },
            {
                colId: "operator",
                header: i18n.t("zhiji.common.operate"),
                type: "Custom",
                width: "21%",
                component: FormOptColumn
            }
        ],
        pageLength: 10,
        pageLengthRank: [10, 20, 30]
    };
};

export const statusOptions = () => {
    return [
        {
            label: i18n.t("zhiji.common.allStatus"),
            value: "all"
        },
        {
            label: i18n.t("zhiji.common.normal"),
            value: "1"
        },
        {
            label: i18n.t("zhiji.form.stopped"),
            value: "0"
        }
    ];
};

export const formTypeOptions = () => {
    return [
        {
            label: i18n.t("zhiji.form.allType"),
            value: "all"
        },
        {
            label: i18n.t("zhiji.form.normal"),
            value: "0"
        },
        {
            label: i18n.t("zhiji.form.urgency"),
            value: "1"
        },

        {
            label: i18n.t("zhiji.form.auto"),
            value: "2"
        }
    ];
};
